export default class IRREGULAR_STATUS {
  static CODE = {
    NONE     : "NONE",
    REQUIRE    : "REQUIRE",
    WAIT         : "WAIT",
  };

  static exists(code) {
    return Object.values(IRREGULAR_STATUS.CODE).includes(code);
  }

  static name(status) {
    switch (status) {
      case IRREGULAR_STATUS.CODE.NONE:
        return 'なし';
      case IRREGULAR_STATUS.CODE.REQUIRE:
        return '要対応';
      case IRREGULAR_STATUS.CODE.WAIT:
        return 'お客様待ち';
      default:
        return '';
    }
  };

}